import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import * as RIntercom from 'react-intercom';
import { IInjectedRootStore } from 'stores';

interface IIntercomProps {
    appID?: string;
    user_id?: string;
    user_hash?: string;
}

@inject('rootStore')
@observer
export class Intercom extends React.Component<IIntercomProps> {
    public componentDidMount(): void {
        // RIntercom.IntercomAPI('show');
    }
    public render(): React.ReactElement | null {
        if (this.options.appID) {
            return <RIntercom.default appID={this.options.appID} {...this.options} />;
        }
        return null;
    }
    private get injected(): IInjectedRootStore {
        return this.props as IInjectedRootStore;
    }
    private get options(): IIntercomProps {
        const options = _.defaults({}, this.props, {
            appID: process.env.REACT_APP_INTERCOM_APP_ID || '',
        });
        // NB: both ID & hash must be present
        const { userId, userHash } = this.injected.rootStore;
        if (userId && userHash) {
            _.set(options, 'user_id', userId);
            _.set(options, 'user_hash', userHash);
        }
        return options;
    }
}
